import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';

// Request Interceptor: Ensure Token is Fresh
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
    return {
        ...config,
        headers: {
            ...config.headers,
            ...(await getAuthHeader()),
        },
    };
});

// Response Interceptor: Handle 401 Errors
axios.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        if (error.response?.status === 401) {
            console.warn(
                'Unauthorized (401) detected, attempting token refresh...',
            );

            try {
                await SettingsStore.updateTokenIfNeed();

                return error.config && axios(error.config); // Retry original request with new token
            } catch (error_) {
                console.error(
                    'Token refresh failed, forcing re-authentication.',
                );
                await AuthStore.authenticate();
            }
        }

        return Promise.reject(error);
    },
);

const getAuthHeader = async () => {
    try {
        await SettingsStore.updateTokenIfNeed();
    } catch {
        AuthStore.authenticate();
    }

    if (SettingsStore.keycloak?.token) {
        return {
            Authorization: `bearer ${SettingsStore.keycloak.token}`,
        };
    }

    return {};
};
